/** @jsxImportSource @emotion/react */
import { useFormatCurrency } from '@quickbit/qb-design-system';
import { SendTransaction, TransactionDetails } from '../types';

export const useTransactionValue = (
  value?: SendTransaction
): [titleId: string, transactionDetails: TransactionDetails] => {
  const formatCurrency = useFormatCurrency();

  switch (value?.type) {
    case 'SEND_INTERNAL':
    case 'SEND_EXTERNAL': {
      const {
        id,
        total,
        totalReference,
        networkFee,
        status,
        destination,
        blockchainExplorerUrl,
        beneficiaryName,
        originatorName,
        serviceFee,
        beneficiaryVaspName,
      } = value as SendTransaction;
      return [
        'sent',
        {
          status: status,
          to: destination ? destination.address : '',
          transactionID: id,
          networkFee: networkFee ? formatCurrency(networkFee) : '',
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          serviceFee: serviceFee ? formatCurrency(serviceFee) : '',
          totalAmount: total
            ? formatCurrency(total)
            : formatCurrency(totalReference),
          blockchainExplorerUrl: blockchainExplorerUrl,
          beneficiaryName,
          originatorName,
          beneficiaryVaspName,
        },
      ];
    }
    default:
      return ['', {}];
  }
};
